import React, { useEffect, useState } from 'react'

/** Cycles through `words`, sliding each new word in. Shows only the first word for reduced motion. */
export function RotatingWords({ words = [], interval = 2400, className = '' }) {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (words.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined
    const timer = setInterval(() => setIndex((current) => (current + 1) % words.length), interval)
    return () => clearInterval(timer)
  }, [words.length, interval])

  if (!words.length) return null
  return (
    <span className={`fx-rotate ${className}`.trim()} aria-live="polite">
      <span key={index} className="fx-rotate__word">
        {words[index]}
      </span>
    </span>
  )
}

/** Endless horizontal ticker; the list is rendered twice so the loop is seamless. Pauses on hover. */
export function Marquee({ items = [], icon = 'fa-circle', speed = 40, className = '' }) {
  if (!items.length) return null
  const row = (hidden) => (
    <ul className="fx-marquee__row" aria-hidden={hidden || undefined}>
      {items.map((item, i) => (
        <li key={`${item}-${i}`}>
          <i className={`fa-solid ${icon}`} aria-hidden="true" />
          {item}
        </li>
      ))}
    </ul>
  )
  return (
    <div className={`fx-marquee ${className}`.trim()} style={{ '--fx-speed': `${speed}s` }}>
      <div className="fx-marquee__track">
        {row(false)}
        {row(true)}
      </div>
    </div>
  )
}

/** Soft gradient shapes drifting behind a section (decorative). */
export function Blobs({ className = '' }) {
  return (
    <span className={`fx-blobs ${className}`.trim()} aria-hidden="true">
      <span className="fx-blob fx-blob--a" />
      <span className="fx-blob fx-blob--b" />
      <span className="fx-blob fx-blob--c" />
    </span>
  )
}
